/** Where the services are, given where this bundle is served from.
 *
 * Paths are written the way the gateway sees them: `/session/v1/...`, `/auth/v1/...`.
 * Traefik (deploy) and the Vite proxy (dev) both route by that first segment and strip it
 * before the service, so the app never knows a port. Two build knobs say where things are
 * (STORY-132; the rule lives in scripts/gateway_base.mjs):
 *
 *   APP_BASE=/               GATEWAY_BASE=            the default: everything at the root
 *   APP_BASE=/proctor/app/   GATEWAY_BASE=/proctor    the bundle one segment below the gateway
 *   APP_BASE=/app/           GATEWAY_BASE=/app        the bundle and the gateway share a mount
 *                                                     point (an app under a path on a host whose
 *                                                     root is someone else's app)
 *
 * Nothing else in the app may spell a root path: scripts/check_base.mjs fails the lint on a
 * `location.assign("/...")` or a `fetch("/...")` that does not go through `serviceUrl`.
 */
const BASE = import.meta.env.BASE_URL;

declare const __GATEWAY_BASE__: string;

/** BASE minus its trailing slash: the router's basepath. */
export const APP_BASE = BASE.replace(/\/+$/, "");

/** The gateway root, stamped at build time; "" when the gateway is at the origin's root. */
export const GATEWAY_BASE: string = __GATEWAY_BASE__;

export function serviceUrl(path: string): string {
  // A path without its leading slash would make a RELATIVE url: `fetch("curriculum/v1/x")`
  // from /t/c/<id>/items asks for /t/c/<id>/curriculum/v1/x, which no route matches, so the
  // SPA catch-all answers index.html with 200 and the caller saves a web page as a .zip.
  // That shipped once (the QTI export); normalising here means it cannot happen again.
  return GATEWAY_BASE + (path.startsWith("/") ? path : `/${path}`);
}

export function wsUrl(path: string): string {
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${location.host}${serviceUrl(path)}`;
}
